// extracted by mini-css-extract-plugin
export default {"countdown":"Rna-z","srOnly":"Sna-z"};